import {IconProps} from '../../types/IconProps'

const ForceChangePrimaryIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      width={width || '29'}
      height={height || '22'}
      viewBox='0 0 29 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='SVGRepo_iconCarrier'>
        <path
          id='Vector'
          d='M16.334 16.8703C16.334 18.377 16.334 19.1303 16.6384 19.4997C16.9028 19.8206 17.3017 19.9997 17.7172 19.9842C18.1955 19.9662 18.7585 19.4658 19.8847 18.4647L26.5402 12.5487C27.1606 11.9973 27.4708 11.7215 27.585 11.3959C27.6854 11.1101 27.6854 10.7985 27.585 10.5125C27.4708 10.1869 27.1606 9.91114 26.5402 9.35981L19.8847 3.44367C18.7585 2.44267 18.1955 1.94218 17.7172 1.92427C17.3017 1.90873 16.9028 2.08789 16.6384 2.40875C16.334 2.77809 16.334 3.53145 16.334 5.03815V16.8703Z'
          stroke={color || '#735BF2'}
          strokeWidth='2.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M1.66699 16.8703C1.66699 18.377 1.66699 19.1303 1.97135 19.4997C2.23575 19.8206 2.63471 19.9997 3.05019 19.9842C3.52845 19.9662 4.09151 19.4658 5.21763 18.4647L11.8732 12.5487C12.4937 11.9973 12.8038 11.7215 12.9181 11.3959C13.0185 11.1101 13.0185 10.7985 12.9181 10.5125C12.8038 10.1869 12.4937 9.91114 11.8732 9.35981L5.21763 3.44367C4.09151 2.44267 3.52845 1.94218 3.05019 1.92427C2.63471 1.90873 2.23575 2.08789 1.97135 2.40875C1.66699 2.77809 1.66699 3.53145 1.66699 5.03815V16.8703Z'
          stroke={color || '#735BF2'}
          strokeWidth='2.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export default ForceChangePrimaryIcon
